import { IFacilityDTO } from '@zunta/configurations'
import { IBaseStore } from '../types'
import { Module, VuexModule, Action } from 'vuex-module-decorators'
import Api from '../../api'

export interface IImportState {
}

export interface IImportStore extends IBaseStore {
  state: IImportState
}

@Module({
  name: 'import',
  namespaced: true
})
export class ImportModule extends VuexModule {
  @Action
  async importFacilities (input: { facilities: IFacilityDTO[], residentsFile: File }) {
    const response = await Api.import.importFacilities(input.facilities, input.residentsFile)
  }
}
